jQuery(document).ready(function ($) {

    $('.author').on('click', function () {
        sport1Analytics.sendEvent('all-commentators-page', 'commentator-click');
    });
});